class Elementor_Event {
    static instance;

    static getInstance() {
        if (!Elementor_Event.instance) {
            Elementor_Event.instance = new Elementor_Event();
        }
        return Elementor_Event.instance;
    }

    constructor() {
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init() {
        elementorFrontend.hooks.addAction('frontend/element_ready/opal-event.default', ($scope) => {
            let $carousel = $scope.find('.owl-carousel');
            if ($carousel.length > 0) {
                let data = $carousel.data('settings');
                $carousel.owlCarousel(Elementor_Carousel.setupData(data));
            }
        });
    }
}


Elementor_Event.getInstance();